import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import Select from 'react-select'
// import BreachCodes from './BreachCodes'

import "../assets/styles/home.scss"
const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/NRLrookieDossier2025/prod/NRLrookieDossier2025.json'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      data: undefined,
      domain: window.location.hostname.replace('www.','').replace('.com.au',''),
      filteredData: [],
      clubOptions: [
        { value: 'All', label: 'All' },
        { value: 'Broncos', label: 'Broncos' },
        { value: 'Bulldogs', label: 'Bulldogs' },
        { value: 'Cowboys', label: 'Cowboys' },
        { value: 'Dolphins', label: 'Dolphins' },
        { value: 'Dragons', label: 'Dragons' },
        { value: 'Eels', label: 'Eels' },
        { value: 'Knights', label: 'Knights' },
        { value: 'Panthers', label: 'Panthers' },
        { value: 'Rabbitohs', label: 'Rabbitohs' },
        { value: 'Raiders', label: 'Raiders' },
        { value: 'Roosters', label: 'Roosters' },
        { value: 'Sea Eagles', label: 'Sea Eagles' },
        { value: 'Sharks', label: 'Sharks' },
        { value: 'Storm', label: 'Storm' },
        { value: 'Titans', label: 'Titans' },
        { value: 'Warriors', label: 'Warriors' },
        { value: 'Wests Tigers', label: 'Wests Tigers' }
      ],
      positionOptions: [
        { value: 'All', label: 'All' },
        { value: 'Centre', label: 'Centre' },
        { value: 'Five Eighth', label: 'Five Eighth' },
        { value: 'Front Rower', label: 'Front Rower' },
        { value: 'Fullback', label: 'Fullback' },
        { value: 'Halfback', label: 'Halfback' },
        { value: 'Hooker', label: 'Hooker' },
        { value: 'Lock', label: 'Lock' },
        { value: 'Second Rower', label: 'Second Rower' },
        { value: 'Wing', label: 'Wing' },
        { value: 'DPP', label: 'DPP only' },
      ],
      priceOptions: [
        { value: 'All', label: 'All' },
        { value: 'u100', label: 'Under $100k' },
        { value: '100-120', label: '$100k - $120k' },
        { value: '121-150', label: '$121k - $150k' },
        { value: '151-200', label: '$151k - $200k' },
        { value: 'o200', label: '$200k+' },
      ],
      filterOptions: [
        { value: 'All', label: 'All' },
        { value: 'Defence', label: 'Defence' },
        { value: 'Footwork', label: 'Footwork' },
        { value: 'Footy_IQ', label: 'Footy IQ' },
        { value: 'General_kicking', label: 'General kicking' },
        { value: 'Goal_kicking', label: 'Goal kicking' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Physicality', label: 'Physicality' },
        { value: 'Power', label: 'Power' },
        { value: 'Speed', label: 'Speed' },
        { value: 'Utility_value', label: 'Utility value' },
        { value: 'Work_rate', label: 'Work rate' },
        { value: 'X-factor', label: 'X-factor' }
      ],
      selectedClub: { label: "All", value: "All" },
      selectedPosition: { label: "All", value: "All" },
      selectedPrice: { label: "All", value: "All" },
      selectedSkill: { label: "All", value: "All" },
      // rookieState: false,
      // selectedSort: 'rTotal',
      // selectedSortDirection: 'desc'
      // activeCard: null,
      activeAll: false,
      breach: null
    }

    // this.siteCode = this.siteCode.bind(this)
    this.loadData = this.loadData.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    
    
  }

  componentDidMount () {
    const isDeskMobAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isMobileApp = ( isDeskMobAttribute === 'mobile' || isDeskMobAttribute === 'desktop' ) ? false : true
    this.state.isMobApp = isMobileApp

    this.loadData()
  }

  loadData () {
    
    axios.get(apiURL_storage)
    .then((response) => {
      let titlesRemoved = response.data.values
      // console.log('response.data.values', response.data.values)
      titlesRemoved.shift()

      function hasMoreThanOneItem(array) {
        return Array.isArray(array) && array.length > 1;
      }

      const cleanData = titlesRemoved.filter( card => card.length )
      const dataPaired = cleanData.map(function(player){
        const newPlayer = {}
        // console.log('player', player)
        newPlayer.id = player[0]
        newPlayer.name = player[1]
        newPlayer.image = player[2] ? player[2] : 'blank'
        newPlayer.club = player[3]
        newPlayer.clubClass = player[3].replace(' ', '-')
        newPlayer.position = player[4] ? player[4].split(", ") : ''
        newPlayer.dpp = hasMoreThanOneItem(player[4].split(", "))
        newPlayer.scprice = player[5]
        newPlayer.scpriceForatted = player[5] === "N/A" 
        ? "N/A" 
        : Number(player[5]).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
        newPlayer.standfirst = player[6]
        newPlayer.bio = player[7]
        newPlayer.state = player[8]
        newPlayer.height = player[9]
        newPlayer.age = player[10]
        newPlayer.school = player[11]
        newPlayer.r1 = player[12]
        newPlayer.skills = player[13] ? player[13].split(", ") : ''
        return newPlayer
      });

      // console.log('dataPaired', dataPaired);

      this.setState({
        data: dataPaired
      }, function () {
        // this.filterList ()
        if ( this.state.breach === true ) {
          this.dataSlash()
        } else {
          this.filterList()
        }
      });

    })
    .catch((err) => {
      console.log('err', err)
    })

  }

  changePos (e) {
    const position = e
    this.setState({
      selectedPosition: position
    }, () => {
      this.filterList()
    })
  }

  changePrice (e) {
    const price = e
    this.setState({
      selectedPrice: price
    }, () => {
      this.filterList()
    })
  }
  
  changeSkill (e) {
    const skill = e
    this.setState({
      selectedSkill: skill
    }, () => {
      this.filterList()
    })
  }

  changeClub (e) {
    const club = e
    this.setState({
      selectedClub: club
    }, () => {
      this.filterList()
    })
  }

  filterList () {
    const filteredList = this.state.data.filter((record) => {
      const matchClub = this.state.selectedClub['value'] === 'All' || record.club === this.state.selectedClub['value'];
      
      const matchPosition = 
        this.state.selectedPosition['value'] === 'All' || 
        record.position.includes(this.state.selectedPosition['value']) || 
        (this.state.selectedPosition['value'] === 'DPP' && record.dpp === true);
      
      const matchSkill = this.state.selectedSkill['value'] === 'All' || record.skills.includes(this.state.selectedSkill['value']);
    
      const matchPrice = (() => {
        const selectedPrice = this.state.selectedPrice['value'];
        const price = record.scprice;

        switch (selectedPrice) {
          case 'u100':
            return price < 100000;
          case '100-120':
            return price >= 100000 && price <= 120999;
          case '121-150':
            return price >= 121000 && price <= 150999;
          case '151-200':
            return price >= 151000 && price <= 200000;
          case 'o200':
            return price > 200000;
          default:
            return true;
        }
      })();
    
      return matchClub && matchPosition && matchSkill && matchPrice;
    });
    

    this.setState({
      filteredData: filteredList
    })

  }

  /* LOAD READER RANKING */
  /*sortByKey (array, key, ascdesc) {
    return array.sort((a, b) => {
      let x = (ascdesc === 'asc') ? b[key] : a[key]
      let y = (ascdesc === 'asc') ? a[key] : b[key]
      return -((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }*/

  expandAll () {
    const newExpandState =  ( this.state.activeAll == false ) ? true : false
    this.setState({
      activeAll: newExpandState
    });

  }

  expandCard (e) {
    // console.log('expandCard e', e)
    const targetRow = e.target.closest('.nnd-player')
    targetRow.classList.toggle(`nnd-active`)
  }

  render() {
    const isBreached = this.state.breach
    const isActiveAll = this.state.activeAll
    const playerTiles = (typeof this.state.filteredData !== 'undefined') ? this.state.filteredData.map((item, index) => {
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item.name+index} className={isActiveAll == true ? 'nnd-player nnd-active' : 'nnd-player'}>
            <div className='nnd-player-tile'>
              <div className="nnd-player-header">
                <div className={`nnd-club nnd-club-${item.clubClass}`}></div>
                <div className="nnd-name">{item.name}</div>
                <div className="nnd-dpp">
                  
                    {item.dpp
                    ?
                    <div className="nnd-dpp-text">
                      DPP
                    </div>
                    :
                      ''
                    }
                </div>
              </div>
              <div className="nnd-player-top">
                <div className="nnd-player-info">
                  
                  <div className="nnd-player-image">
                    <img loading="lazy" alt={item.name} src={require(`../assets/images/${item.image}.jpg`)} />
                    <div className="nnd-player-position">{item.position.join(", ")}</div>
                  </div>
                  {item.standfirst ? <div className="nnd-standfirst">{item.standfirst}</div> : '' }
                  <div className="nnd-info">
                    {item.club ? <p className="nnd-club"><span>Club</span> {item.club}</p> : '' }
                    {item.scpriceForatted ? <p className="nnd-price"><span>SC Price</span> {item.scpriceForatted}</p> : '' }
                    {item.state ? <p className="nnd-state"><span>State</span> {item.state}</p> : '' }
                    {item.height ? <p className="nnd-height"><span>Height</span> {item.height}</p> : '' }
                    {item.age ? <p className="nnd-age"><span>Age</span> {item.age}</p> : '' }
                    {item.school ? <p className="nnd-school"><span>School</span> {item.school}</p> : '' }
                    {item.r1 ? <p className="nnd-r1"><span>R1 Chances</span> {item.r1}</p> : '' }
                  </div>
                  <div className="nnd-skills">
                  {Array.isArray(item.skills) && item.skills.length > 0 && item.skills.map(skill => (
                    <div key={skill} className={`nnd-skill nnd-${skill}`}>
                      <div className={`nnd-icon nnd-icon-${skill}`}>
                        <img src={require(`../assets/images/icon-${skill.replace(' ', '')}.svg`)} alt={skill} />
                      </div>
                      {skill.replaceAll('_', ' ')}
                    </div>
                  ))}
                  </div>
                  
                  <div className="nnd-cta-wrap">
                    <div className="nnd-cta" onClick={(e) => { this.expandCard(e); e.preventDefault() }}>
                      <div className="nnd-cta-text">
                        <span className="nnd-cta-name expand" title="Full Rookie Report">Full Rookie Report</span>
                        <span className="nnd-cta-name hide" title="Hide">Hide</span>
                        {/*<span className="nnd-cta-pos" title={ item.position }>{ item.position}</span>*/}
                      </div>
                      <div className="nnd-cta-icon" data-index={item.id}>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='nnd-player-tile-expanded'>
              <div className="nnd-player-content">
                <div className="nnd-player-content-inner">
                  <div className="nnd-player-text-profile">
                    <p>{ item.bio }</p>
                    {item.data 
                      ?
                      <p className="nnd-stats" dangerouslySetInnerHTML={{__html: item.data}}></p>
                      :
                      ''
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }) : ''

    const isMobApp = this.state.isMobApp
    const domain = this.state.domain
    // const siteDomain = this.state.siteDomain
    // const isActiveCard = this.state.activeCard

    return (
      <div id="nnd-container" className={`nnd-${domain}`} data-ismobapp={isMobApp}>
        <div className="nnd-header">
          <h2> NRL <span>2025 Rookies to Watch dossier</span></h2>
          <img src={require('../assets/images/header.jpg')} />
        </div>

        <div className="nnd-navigation">
          <div className="nnd-navigation-row">
            <Select 
              onChange={event => this.changeClub(event)} 
              className="nnd-state" 
              classNamePrefix="nnd-select" 
              // isMulti 
              options={this.state.clubOptions}
              placeholder="Club"
            />

            <Select 
              onChange={event => this.changePos(event)} 
              className="nnd-pos" 
              classNamePrefix="nnd-select" 
              // isMulti 
              options={this.state.positionOptions} 
              // defaultValue={this.state.selectedSkill}
              placeholder="Position"
            />

            <Select 
              onChange={event => this.changePrice(event)} 
              className="nnd-price" 
              classNamePrefix="nnd-select" 
              // isMulti 
              options={this.state.priceOptions} 
              // defaultValue={this.state.selectedSkill}
              placeholder="Price"
            />

            
          </div>


          <div className="nnd-navigation-rowSwitch">
            
            <Select 
              onChange={event => this.changeSkill(event)} 
              className="nnd-filter" 
              classNamePrefix="nnd-select" 
              // isMulti 
              options={this.state.filterOptions} 
              // defaultValue={this.state.selectedSkill}
              placeholder="Skill"
            />
            
            <label className="nnd-switchWrap" >
              <span className="nnd-switchText">Full Scouting Report</span>
              <div className="nnd-switch">
                <input type="checkbox" onChange={() => this.expandAll()} />
                <span className="nnd-slider nnd-round"></span>
              </div>
            </label>
          </div>

        </div>
        
        <div className="nnd-cont-main-wrap">
          <div className="nnd-cont-main" ref="scroller">
            <div className="nnd-tiles">
              {playerTiles.length > 0
              ?
              playerTiles
              :
              <div className="nnd-noMatch">No players match these filters</div>
              }
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js